export const blockIconsUiactionsOpenInNewNew = (
	<span className='material-symbols-outlined'>open_in_new</span>
);
